import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import AdminSidebar from "./AdminSidebar";
import { AdminSidebarContent } from "./AdminSidebarContent";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTitle } from "./ui/sheet";
import { postRodauth } from "../lib/rodauth";
import { useCurrentUser } from "../hooks/useCurrentUser";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { refetch } = useCurrentUser();

  const handleLogout = async () => {
    setSidebarOpen(false);
    await postRodauth("/logout", {});
    await refetch();
    navigate("/login", { replace: true });
  };

  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950 flex">
      <AdminSidebar />

      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <SheetContent
          side="left"
          className="flex w-56 flex-col p-0 font-light bg-white dark:bg-primary-900 border-primary-200 dark:border-primary-800"
        >
          <SheetTitle className="sr-only">Menu de administração</SheetTitle>
          <AdminSidebarContent onNavigate={closeSidebar} onLogout={handleLogout} />
        </SheetContent>
      </Sheet>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center gap-3 border-b border-primary-200 bg-white px-4 py-4 dark:border-primary-800 dark:bg-primary-900 md:hidden">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            aria-label="Abrir menu"
            aria-expanded={sidebarOpen}
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="h-5 w-5" />
          </Button>
          <div>
            <p className="text-xs font-light tracking-widest uppercase text-primary-500">Admin</p>
            <p className="text-sm font-light text-primary-900 dark:text-white">WhatsApp Store</p>
          </div>
        </header>

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
